import Flickity from "flickity";

export default class BasePostGridSlider
{
    /**
     * @var {object}
     */
    currentFilters = {};

    /**
     * @var {HTMLElement}
     */
    postGrid = null;

    /**
     * @var {boolean}
     */
    autoplay = false;

    /**
     * @var {boolean}
     */
    infinite = false;

    /**
     * @var {array}
     */
    slides = null;

    /**
     * @var {HTMLElement}
     */
    slider = null;

    /**
     * @var {HTMLElement}
     */
    sliderContainer = null;

    /**
     * @var {int}
     */
    totalWidth = 0;

    /**
     * @var {int}
     */
    slideXTotal = 0;

    /**
     * @var {int}
     */
    selectedIndex = 0;

    /**
     * @var {boolean}
     */
    isLoading = false;

    /**
     * @var {object}
     */
    currentFilters = {};

    /**
     * @var {HTMLElement}
     */
    postGrid = null;

    /**
     * @var {object}
     */
    filterPrefix = {
        'taxonomy': 'filter-t-',
        'meta' : 'filter-m-',
        'search': '',
    };

    /**
     * @var {boolean}
     */
    updateHistory = true;

    constructor(autoplay, infinite) {
        this.autoplay = autoplay || false;
        this.infinite = infinite || false;
    };

    /**
     * init
     * 
     * @return void
     */
    init() {

        this.postGrid = this.$el;
        this.currentFilters = this.getCurrentFilters();
        
        this.initSlider();

        this.getSlideXTotal(this.slides);

        this.updateTabIndexes(this.slides);

        this.updateProgressBar();

        pegasus.onResizeFinished(() => {
            this.sliderResize();

            this.totalWidth = 0;

            this.getSlideXTotal(this.slides);

            this.updateProgressBar();
        });

    };

    initSlider() {
        if(this.slider !== null){
            this.slider.destroy();
        }

        this.sliderContainer = this.$refs.slider;
        this.slides = this.sliderContainer.querySelectorAll(".slide");

        let options = {
            cellAlign: "left",
            contain: true,
            wrapAround: this.infinite,
            prevNextButtons: false,
            pageDots: false,
            draggable: true,
            on: {
                settle: () => {
                    this.updateTabIndexes(this.slides);
                },
                change: () => {
                    this.selectedIndex = this.slider.selectedIndex;
                },
            },
        };

        if (this.autoplay && this.autoplay > 0) {
            options.autoPlay = this.autoplay * 1000;
        }

        this.slider = new Flickity(this.sliderContainer, options);

        this.slider.on("scroll", (e) => {
            this.updateProgressBar();
        });

    }

    /**
     * getSlideXTotal
     * 
     * @param {array} slides 
     * @return void
     */
    getSlideXTotal(slides) {
        slides.forEach((slide) => {
            this.totalWidth += slide.offsetWidth;
        });

        if(this.infinite) {
            this.slideXTotal = (this.totalWidth - this.sliderContainer.offsetWidth) + ((this.sliderContainer.offsetWidth / 2) + (this.totalWidth / slides.length));
        } else {
            this.slideXTotal = this.totalWidth - this.sliderContainer.offsetWidth;
        }
    }

    /**
     * updateTabIndexes
     *
     * Description: Updates the tabindexes of the slides this is required for accessibility.
     * Inactive slides shouldn't be accessible via the keyboard.
     *
     * @param {} slides
     * @return void
     */
    updateTabIndexes(slides) {
        slides.forEach((slide) => {
            const slideElements = slide.querySelectorAll("a, button");

            slideElements.forEach((element) => {
                if (slide.classList.contains("is-selected")) {
                    element.removeAttribute("tabindex");
                } else {
                    element.setAttribute("tabindex", "-1");
                }
            });
        });
    };

    /**
     * updateProgressBar
     * 
     * @return void
     */
    updateProgressBar() {
        const progressBar = this.$refs.progressBar;
        if(!progressBar) return;
        const progress = (Math.abs(this.slider.x) / this.slideXTotal) * 100;
        progressBar.style.width = progress + "%";
    };

    /**
     * sliderResize
     * 
     * @return void
     */
    sliderResize() {

        if(this.sliderContainer === null) return;

        const flickitySliders = this.sliderContainer.querySelectorAll('.flickity-slider');

        this.sliderFullWidth = 0;

        flickitySliders.forEach(slider => {
            let height = 0;

            this.slides.forEach(slide => {
                slide.style.height = '';
                if(slide.offsetHeight > height){
                    height = slide.offsetHeight;
                }
            });

            this.slides.forEach(slide => {
                slide.style.height = height+'px';
            })

            slider.style.height = '';
            slider.style.height = height+'px';

            console.log(slider.offsetHeight);

        });

    }

    /**
     * toggleFilters
     * 
     * Description: Either add or remove the filter term from 
     * it's taxonomy.
     * 
     * @param {string} term
     * @param {string} filterName
     * @param {string} type
     * @return void
     */
    toggleFilters(term = '', filterName = '', type = 'taxonomy'){

        const filter = this.getPrefixedFilter(filterName, type);

        // If this is the first filter to be added, just add it.
        if(typeof this.currentFilters[filter] === "undefined"){
            this.currentFilters[filter] = term;

            // Refresh the post grid content
            this.fetchContent();
            return;
        }

        // If we have filters for the current filter, check if the term is already in the list.
        if(this.currentFilters[filter].length){

            if(this.currentFilters[filter].includes(term)) {
                // If the term is already in the list, remove it from the filter.
                this.currentFilters[filter] = this.removeFilter(filter, term);
                // If this filter filter is now empty, remove it from the current filters.
                if(!this.currentFilters[filter].length){
                    delete this.currentFilters[filter];
                }
            } else {
                // If the term is not already in the list, add it.
                this.currentFilters[filter] += ','+term
            }
        } else {
            // If there isn't a filter for this filter, add it and then add the term to it.
            this.currentFilters[filter] = term;
        }

        // Refresh the post grid content
        if(fetch){
            this.fetchContent();
        }

    }

    /**
     * removeFilter
     * 
     * Description: Removes a given term from it's taxonomy filter.
     * 
     * @param {string} filter
     * @param {string} value
     * @return string
     */
    removeFilter(filter, value){
        // Get the filter values from the currentFilters array
        const filterValue = this.currentFilters[filter];

        // Turn the filter values into an array
        const filterValueArray = filterValue.split(',');

        // Loop through the array and remove the given value
        for(let i = 0; i < filterValueArray.length; i++){
            if (filterValueArray[i] === value) { 
                filterValueArray.splice(i, 1); 
            }   
        }

        // Return the array as a string
        return filterValueArray.toString();
    }

    /**
     * clearFilters
     * 
     * Description: Empty the current filters and refresh the page.
     * 
     * @return void
     */
    clearFilters() {
        this.currentFilters = {};
        window.location.href = window.location.protocol + '//' + window.location.hostname + window.location.pathname;
    }

    /**
     * fetchContent
     * 
     * Description: Requests the new post grid based on the current 
     * filters and replaces the current post grid with it's content.
     * 
     * @param {string} href
     * @return void
     */
    fetchContent(href = null){

        // Get the post grid container and the data selector for the post grid.
        const postGrid = this.postGrid.querySelector('[data-pegasus-filterable]');
        const elements = ['data-pegasus-filterable="'+postGrid.dataset.pegasusFilterable+'"'];
        let currentUrl = '';

        // If there are no filters, just refresh the page.
        if(!Object.keys(this.currentFilters).length){
            if(href){
                currentUrl = href;
            } else {
                window.location.href = window.location.protocol + '//' + window.location.hostname + window.location.pathname;
                return;
            }
            
        } else {
            // If there are filters, build the url and set it as the current url.
            currentUrl = this.buildUrl();
        }

        // If a href is passed in, use that instead of the current url.
        if(href){
            currentUrl = href;
        }
        
        // Only allow a request to happen whilst we're not waiting for a response.
        if(!this.isLoading){
            this.isLoading = true;
            // Run the ajaxContent function from pegasus.
            pegasus.ajaxContent(currentUrl, elements, {}, () => {
                this.isLoading = false;

                // rebuild the slider
                this.initSlider();

                // Update the url with the current filters.
                if(this.updateHistory) {
                    history.pushState(JSON.stringify(this.currentFilters), '', currentUrl);
                }

                // Scroll to the top of the post grid.
                pegasus.scroll(this.postGrid);

                // If the post grid items open in modals make sure to re-initialise them.
                if(typeof window.modal !== "undefined"){
                    window.modal.init();
                }

            });
        }
    }

    /**
     * getCurrentFilters
     * 
     * Description: Get the current filters from the url.
     * 
     * @return object
     */
    getCurrentFilters(){
        // Get the current url and parse the query string.
        const url = new URL(window.location.href);
        const params = new URLSearchParams(url.search);

        let currentFilters = {};

        // Loop through the query string and add each filter to the currentFilters object.
        for (const [key, value] of params.entries()) {
            currentFilters[key] = value;
        }

        return currentFilters;

    }

    /**
     * filterIsActive
     * 
     * Description: Checks if a given filter is currently selected.
     * 
     * @param {string} filter
     * @param {string} term
     * @param {string} type
     * @return {boolean}
     */
    filterIsActive(term, filter, type = 'taxonomy'){
        const filterName = this.getPrefixedFilter(filter, type);
        if(typeof this.currentFilters[filterName] !== "undefined"){
            return this.currentFilters[filterName].includes(term);
        }
        return false;
    }

    /**
     * buildUrl
     * 
     * Description: Build the URL to request from based on the current filters.
     * 
     * @return void
     */
    buildUrl(){
        // Set the URL to the current page.
        let url = window.location.protocol + '//' + window.location.hostname + window.location.pathname + '?';
        let i = 1

        // Loop through the filters and add them to the URL
        for (const [key, value] of Object.entries(this.currentFilters)) {
            url += `${key}=${value}`
            if(i < Object.keys(this.currentFilters).length){
                url+='&'
            }
            i++
        }

        return url;
    }

    /**
     * getPrefixedFilter
     * @param {string} filter
     * @param {string} type
     * @return {string}
     */
    getPrefixedFilter(filter, type = 'taxonomy'){
        return `${this.filterPrefix[type]}${filter}`;
    }

}

document.addEventListener("alpine:init", () => {
    Alpine.data("postGridSlider", (autoplay, infinite) => new BasePostGridSlider(autoplay, infinite));
});
